module.exports = __webpack_public_path__ + "img/logo-more.0b6a0549.png";